var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitchaccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0456 0H19.9544C8.9339 0 0 8.93392 0 19.9545V20.0455C0 31.0661 8.9339 40 19.9544 40H20.0456C31.0661 40 40 31.0661 40 20.0455V19.9545C40 8.93392 31.0661 0 20.0456 0Z",
    fill: "#A544FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7636 9.58276L9.30859 14.0378V30.074H14.6535V34.529L19.1086 30.074H22.6723L30.6911 22.0552V9.58276H13.7636ZM28.9085 21.1639L25.3448 24.7276H21.781L18.6629 27.8457V24.7276H14.6535V11.3639H28.9085V21.1639Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2343 14.4834H24.4531V19.8283H26.2343V14.4834Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3359 14.4835H19.5547V19.8284H21.3359V14.4835Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchaccount);
export default __webpack_public_path__ + "static/media/Twitchaccount.92d66d9357913c569a5d16c2bed5d442.svg";
export { ForwardRef as ReactComponent };